import {
  calculateDurationFromTimeTrackerData,
  formatMillisecondsToDurationString,
} from '@shared/components/timer';
import { TimeTrackerComponentData } from '@shared/data/entity/fields/TimeTrackerField';

/**
 * A timer's total tracked time as of `now`: "45m 00s", or with every unit, as a table cell's
 * width allowance measures it, "0d 0h 45m 00s".
 */
export function getTimerText(
  entries: TimeTrackerComponentData,
  showEmptyUnits = false,
  now: Date = new Date(),
): string {
  const duration = calculateDurationFromTimeTrackerData(entries, now);
  return formatMillisecondsToDurationString(duration, showEmptyUnits);
}
